import React from 'react';
import { Form, Formik } from 'formik';
import FormikFieldWrapper from '../general/formikFieldWrapper/formikFieldWrapper';
// @ts-ignore
import { Button } from 'arag-ui-lib';
import moment from 'moment';
import styles from '../general/styles/generalLabels.module.scss';
import { GroupButtons, Content, Filters } from '../../hosc/filters/filters';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/i18n';

type Props = {
    handleFormSubmit: (formValues: any) => any;
    handleFormReset: (formikResetForm: () => void) => any;
};

const submittedByList = () => [
    { key: '', label: '' },
    {
        label: 'ARAG',
        key: 'ARAG',
    },
    {
        label: i18n.t('claimant'),
        key: 'CLAIMANT',
    },
];
const formValidator = (values: {
    submissionDateStart: moment.MomentInput;
    submissionDateEnd: moment.MomentInput;
}): any => {
    const errors: {
        submissionDateStart: string;
        submissionDateEnd: string;
    } = {
        submissionDateStart: '',
        submissionDateEnd: '',
    };
    if (
        values.submissionDateStart &&
        values.submissionDateEnd &&
        moment(values.submissionDateStart).isAfter(values.submissionDateEnd)
    ) {
        errors.submissionDateStart = 'Submission date cannot be after to date';
        errors.submissionDateEnd = 'To date cannot be prior to submission date';
    }

    return errors;
};

const dateQuestionRestrictions = (
    fieldName: string,
    formValues: {
        [x: string]: moment.MomentInput;
        submissionDateStart?: moment.MomentInput;
        submissionDateEnd?: moment.MomentInput;
    },
) => {
    let min, max;

    if (
        fieldName === 'submissionDateStart' &&
        formValues['submissionDateEnd']
    ) {
        min = null;
        max = moment(formValues['submissionDateEnd']).toDate();
    }

    if (
        fieldName === 'submissionDateEnd' &&
        formValues['submissionDateStart']
    ) {
        min = moment(formValues['submissionDateStart']).toDate();
        max = null;
    }

    return { min, max };
};

const ClaimDocumentListFiltersForm = (props: Props): JSX.Element => {
    const { handleFormReset, handleFormSubmit } = props;
    const { t } = useTranslation();
    return (
        <div className="row">
            <Formik
                initialValues={{} as any}
                onSubmit={handleFormSubmit}
                validate={formValidator}
            >
                {formikProps => {
                    const toDateRestrictions = dateQuestionRestrictions(
                        'submissionDateEnd',
                        formikProps.values,
                    );
                    return (
                        <Form
                            className="form-horizontal"
                            autoComplete="off"
                            autoCorrect="off"
                            spellCheck="false"
                        >
                            <Filters>
                                <Content>
                                    <FormikFieldWrapper
                                        labelSize={'col-sm-3'}
                                        inputSize={'col-sm-7'}
                                        label={t('submittedBy')}
                                        variant={'select'}
                                        getInputProps={(formikBag: {
                                            field: { value: any };
                                        }) => ({
                                            ...formikBag,
                                            name: 'submittedByAragUserOnly',
                                            value: formikBag.field.value || '',
                                            options: submittedByList(),
                                            onChange: (
                                                evt: React.ChangeEvent<HTMLInputElement>,
                                            ) =>
                                                formikProps.setFieldValue(
                                                    'submittedByAragUserOnly',
                                                    evt.target.value,
                                                ),
                                        })}
                                        inputProps={{
                                            name: 'submittedByAragUserOnly',
                                        }}
                                    />
                                    <FormikFieldWrapper
                                        labelSize={'col-sm-3'}
                                        inputSize={'col-sm-7'}
                                        label={t('nameOfDocument')}
                                        variant={'text'}
                                        getInputProps={(formikBag: {
                                            field: { value: any };
                                        }) => ({
                                            ...formikBag,
                                            name: 'attachmentFullFileNameLike',
                                            value: formikBag.field.value || '',
                                        })}
                                        inputProps={{
                                            name: 'attachmentFullFileNameLike',
                                            placeholder:
                                                'Please type the name of the document',
                                        }}
                                    />
                                    <div className={'form-group'}>
                                        <div style={{ marginTop: '-15px' }}>
                                            <FormikFieldWrapper
                                                inline
                                                labelSize={'col-sm-3'}
                                                inputSize={'col-sm-3'}
                                                label={t('submissionDate')}
                                                variant={'date'}
                                                getInputProps={(formikBag: {
                                                    field: {
                                                        value:
                                                            | string
                                                            | number
                                                            | Date;
                                                        name: any;
                                                    };
                                                    setFieldValue: (
                                                        field: { name: string },
                                                        value: string,
                                                    ) => any;
                                                }) => ({
                                                    ...formikBag,
                                                    dateInputProps: {
                                                        showYearDropdown: true,
                                                        showMonthDropdown: true,
                                                        dropdownMode: 'select',
                                                        dateFormat:
                                                            'dd/MM/yyyy',
                                                        selected: formikBag
                                                            .field.value
                                                            ? new Date(
                                                                  formikBag
                                                                      .field
                                                                      .value,
                                                              )
                                                            : '',
                                                        name: 'submissionDateStart',
                                                        onChange: (
                                                            value: any,
                                                        ) =>
                                                            formikBag.setFieldValue(
                                                                formikBag.field
                                                                    .name,
                                                                value,
                                                            ),
                                                        minDate: new Date(
                                                            2020,
                                                            12,
                                                            1,
                                                        ),
                                                        maxDate: Date.now(),
                                                    },
                                                })}
                                                inputProps={{
                                                    name: 'submissionDateStart',
                                                }}
                                            />
                                        </div>
                                        <div style={{ marginTop: '-15px' }}>
                                            <FormikFieldWrapper
                                                inline
                                                labelSize={`col-sm-1 ${styles['search-label']}`}
                                                inputSize={'col-sm-3'}
                                                label={t('to')}
                                                variant={'date'}
                                                getInputProps={(formikBag: {
                                                    field: {
                                                        value:
                                                            | string
                                                            | number
                                                            | Date;
                                                        name: any;
                                                    };
                                                    setFieldValue: (
                                                        field: { name: string },
                                                        value: string,
                                                    ) => any;
                                                }) => ({
                                                    dateInputProps: {
                                                        showYearDropdown: true,
                                                        showMonthDropdown: true,
                                                        dropdownMode: 'select',
                                                        dateFormat:
                                                            'dd/MM/yyyy',
                                                        selected: formikBag
                                                            .field.value
                                                            ? new Date(
                                                                  formikBag
                                                                      .field
                                                                      .value,
                                                              )
                                                            : '',
                                                        name: 'submissionDateEnd',
                                                        onChange: (
                                                            value: any,
                                                        ) =>
                                                            formikBag.setFieldValue(
                                                                formikBag.field
                                                                    .name,
                                                                value,
                                                            ),
                                                        minDate:
                                                            toDateRestrictions.min,
                                                        maxDate: Date.now(),
                                                    },
                                                })}
                                                inputProps={{
                                                    name: 'submissionDateEnd',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Content>
                                <GroupButtons
                                    main={
                                        <Button
                                            variant="primary"
                                            label={t('filterDocuments')}
                                            arrowDirection="right"
                                            type="submit"
                                            onClick={() =>
                                                handleFormSubmit(
                                                    formikProps.values,
                                                )
                                            }
                                        />
                                    }
                                    secondary={
                                        <Button
                                            variant="quaternary"
                                            label={t('clearFilters')}
                                            arrowDirection="right"
                                            onClick={handleFormReset(
                                                formikProps.resetForm,
                                            )}
                                        />
                                    }
                                />
                            </Filters>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default ClaimDocumentListFiltersForm;
